import { render, staticRenderFns } from "./jumpList.vue?vue&type=template&id=37954bb0"
import script from "./jumpList.vue?vue&type=script&lang=js"
export * from "./jumpList.vue?vue&type=script&lang=js"
import style0 from "./jumpList.vue?vue&type=style&index=0&id=37954bb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports